import {HeightAnimation} from './animations/HeightAnimation';

export class Accordion {

    private container: JQuery;

    constructor(container:JQuery) {
        this.container=container;
        this.container.find('.accordion-header').on('click keydown',(evt)=>this.toggleEvent(evt));
    }

    private toggleEvent(ev:JQuery.TriggeredEvent) {
        if(ev.type == 'keydown' && ev.which != 32 && ev.which != 13) return;
        ev.preventDefault();
        var header=$(ev.target).closest('.accordion-header');
        if (!header.length) return;
        var item=header.closest('.accordion-item');
        if (!item.length) return;

        var body=item.find('.accordion-body');
        if (!body.length) return;

        var otherOpenItems=this.container.find('.accordion-item.open').not(item);
        otherOpenItems.removeClass('open');
        otherOpenItems.each(
            (idx,e)=>{
                var ex=$(e);
                ex.find('.accordion-header').attr('aria-expanded',"false");
                ex.trigger('accordion.close');
                var ebody=ex.find('.accordion-body');
                ex.removeClass('open');
                var ani=new HeightAnimation(ebody);
                ani.from('auto').to(0);
                ani.play();
            }
        );

        var ani=new HeightAnimation(body);

        if (item.hasClass('open')) {
            item.removeClass('open');
            item.addClass('closing');
            item.trigger('accordion.close');
            ani.from('auto').to(0).play().on('end',()=>item.removeClass("closing"));
            if(header.attr('aria-expanded')) header.attr('aria-expanded','false');
        } else {
            item.addClass('open');
            item.addClass('opening');
            item.trigger('accordion.open');
            ani.from(0).to('auto').play().on('end',()=>item.removeClass("opening"));
            if(header.attr('aria-expanded')) header.attr('aria-expanded','true');
        }
    }

}

export {};